// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import EntryGate from "./pages/EntryGate";
import BookingOwnerPage from "./pages/BookingOwnerPage";
import FeedbackPage from './pages/FeedbackPage';
import Home from './pages/Home';
import CustomerSupportPage from './pages/CustomerSupportPage';
import DigitalKeyPage from './pages/DigitalKeyPage';
import HotelDirectoryPage from './pages/HotelDirectoryPage';
import LoyaltyProgramPage from './pages/LoyaltyProgramPage';
import CheckoutPage from './pages/CheckoutPage';
import RoomServicePage from './pages/RoomServicePage';
import WrongRoute from './pages/WrongRoute';
import ProtectedRoute from "./components/ProtectedRoute";
import SelfCheckin from "./pages/SelfCheckin";
import GuestVerification from "./pages/GuestVerification";
import EmailCollector from "./pages/EmailCollector";
import { ReservationProvider } from "./context/ReservationContext";
import { BookingProvider } from "./context/BookingContext";
import './App.css';
import './styles/tailwind.css';
import Goodbye from "./pages/Goodbye";
import AccessDenied from "./pages/AccessDenied";
import NotAvailableYet from "./pages/NotAvailableYet";



function App() {
  return (
    <Router>
      <BookingProvider>
        <ReservationProvider>
          <Routes>
            {/* Catch-all route for reservation IDs */}
            <Route path="/" exact element={<WrongRoute />} />
            <Route path="/b/:bookingAccessToken" element={<BookingOwnerPage />} />
            <Route path="/j/:guestAccessToken" element={<EntryGate />} />
            {/* Old insecure guest URL shape intentionally disabled: /:reservationCode/:hotelName/ */}
            {/* Protected Pages */}
            <Route
              path="/self-checkin"
              element={
                <SelfCheckin />
              }
            />
            <Route
              path="/verify-guest"
              element={
                <GuestVerification />
              }
            />
            <Route
              path="/collect-emails"
              element={
                <ProtectedRoute>
                  <EmailCollector />
                </ProtectedRoute>
              }
            />
            <Route
              path="/home"
              element={
                <ProtectedRoute >
                  <Home />
                </ProtectedRoute>
              }
            />
            {/* accessType={["booker", "guest"]} */}
            {/* Regular routes with protection */}
            <Route path="/feedback" element={<ProtectedRoute><FeedbackPage /></ProtectedRoute>} />
            <Route path="/customer-support" element={<ProtectedRoute><CustomerSupportPage /></ProtectedRoute>} />
            <Route path="/digital-key" element={<ProtectedRoute><DigitalKeyPage /></ProtectedRoute>} />
            {/* <Route path="/digital-key" element={<DigitalKeyPage />} /> */}
            <Route path="/hotel-directory/:propertyCode/places/:placeSlug" element={<ProtectedRoute><HotelDirectoryPage /></ProtectedRoute>} />
            <Route path="/hotel-directory/:propertyCode" element={<ProtectedRoute><HotelDirectoryPage /></ProtectedRoute>} />
            <Route path="/hotel-directory" element={<ProtectedRoute><HotelDirectoryPage /></ProtectedRoute>} />
            <Route path="/loyalty-program" element={<ProtectedRoute><LoyaltyProgramPage /></ProtectedRoute>} />
            <Route path="/checkout" element={<ProtectedRoute><CheckoutPage /></ProtectedRoute>} />
            <Route path="/room-service" element={<ProtectedRoute><RoomServicePage /></ProtectedRoute>} />
            <Route path="/goodbye" element={<Goodbye />} />
            <Route path="/access-denied" element={<AccessDenied />} />
            <Route path="/not-available-yet" element={<NotAvailableYet />} />
          </Routes>
        </ReservationProvider>
      </BookingProvider>
    </Router>

  );
}

export default App;
